import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { H5, Image, SVG } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { Link } from "react-router-dom";
import { Href, Users, UsersCards } from "../../../../utils/Constant";
import { userCardData } from "../../../../Data/Application/Users/UserCards/UserCards";
import SocialMediaIcons from "./SocialMediaIcons";
import UserCardsFooter from "./UserCardsFooter";
import Breadcrumbs from "../../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import apiRequestHelper from "../../../../utils/apiRequestHelper";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { Btn } from "../../../../AbstractElements";
import CenteredModal from "../../../Ui-Kits/Modal/CenteredModal/CenteredModal";
import EyeIcon from "./EyeIcon";
interface UserType {
  id: number;
  title: string;
  slug: string;
  pictureUrl: string;
  isPublished: boolean;
  scheduledDate?: string; // 👈 Add scheduledDate
}

// add any other fields your API returns
const BlogCardsContainer = () => {
  const [users, setUsers] = useState<UserType[]>([]);
  const [selectedBlogId, setSelectedBlogId] = useState<number | null>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const location = useLocation();
  const currentPathname = location.pathname;
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await apiRequestHelper.get("/blogs");

        setUsers(response.data.data.blogs); // Adjust based on your API structure
      } catch (error: any) {
        toast.error(
          error.response?.data?.messages?.[0]?.message || "Failed to load Blogs"
        );
      }
    };

    fetchUsers();
  }, []);
  const handleDeleteSuccess = () => {
    setUsers((prev) => prev.filter((blog) => blog.id !== selectedBlogId));
  };
  const togglePublish = async (id: number, currentStatus: boolean) => {
    console.log("Toggling publish status for blog ID:", id);
    console.log("Current status:", currentStatus);
    try {
      const response = await apiRequestHelper.put(`/blogs/${id}/publish`, {
        action: currentStatus ? "unpublish" : "publish",
      });
      toast.success(
        `Blog ${!currentStatus ? "published" : "unpublished"} successfully!`
      );

      // Update state
      setUsers((prev) =>
        prev.map((blog) =>
          blog.id === id ? { ...blog, isPublished: !currentStatus } : blog
        )
      );
    } catch (error: any) {
      toast.error(
        error.response?.data?.messages?.[0]?.message ||
          "Failed to update blog status"
      );
    }
  };
  const canPublish = (scheduledDate?: string): boolean => {
    if (!scheduledDate) return true;
    const now = new Date();
    const scheduled = new Date(scheduledDate);
    return scheduled <= now; // Only allow if scheduledDate <= today
  };
  return (
    <>
      <Breadcrumbs mainTitle={"Blog Cards"} parent={"Blog"} />
      <Container fluid>
        <Row className="user-cards-items user-card-wrapper">
          {users.map((item) => (
            <Col
              xl="6"
              sm="12"
              xxl="6"
              // className="col-ed-4 box-col-4"
              key={item.id}
            >
              <Card className="social-profile">
                <CardBody>
                  <Row>
                    <Col xl="9" sm="12" xxl="9">
                      {item.pictureUrl && (
                        <img
                          src={item.pictureUrl}
                          className="img-fluid"
                          style={{
                            width: "100%",
                            aspectRatio: "3 / 1", // 👈 ensures square ratio
                            objectFit: "cover",
                            borderRadius: "8px", // optional for rounded corners
                          }}
                          alt="Blog"
                        />
                      )}
                      <div className="social-details">
                        <H5 className="mb-1">
                          <span style={{ color: "white" }}>{item.title}</span>
                        </H5>
                        {item.slug && (
                          <span className="" style={{ color: "white" }}>
                            https://www.dentopia.marketing/blog/{item.slug}
                          </span>
                        )}
                        {item.scheduledDate && (
                          <div className="mt-3">
                            {item.isPublished &&
                            canPublish(item.scheduledDate) ? (
                              <>
                                <span
                                  className="f-12 p-2"
                                  style={{
                                    background: "#00AC46", // green
                                    borderRadius: "5px",
                                    color: "#fff",
                                  }}
                                >
                                  Published
                                </span>{" "}
                                <span style={{ color: "white" }}>
                                  {new Date(
                                    item.scheduledDate
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  })}
                                </span>
                              </>
                            ) : (
                              <>
                                <span
                                  className="f-12 p-2"
                                  style={{
                                    background: "#FF9800", // orange
                                    borderRadius: "5px",
                                    color: "#fff",
                                  }}
                                >
                                  UnPublished
                                </span>{" "}
                                <span style={{ color: "white" }}>
                                  {new Date(
                                    item.scheduledDate
                                  ).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric",
                                  })}
                                </span>
                              </>
                            )}
                          </div>
                        )}
                      </div>
                    </Col>
                    {/* {item.author && (
                      <span className="f-light">{item.author}</span>
                    )} */}
                    {/* <SocialMediaIcons listClassName="card-social" /> */}
                    <Col xl="3" sm="12" xxl="3">
                      <Row>
                        <Col>
                          <div className="text-center d-flex flex-column gap-3 pt-3">
                            <Link
                              to={`/blogs/seo/${item.id}`}
                              className="w-100"
                            >
                              <Btn color="success" className="w-100">
                                SEO
                              </Btn>
                            </Link>
                            <Link
                              to={`/blogs/cta/${item.id}`}
                              className="w-100"
                            >
                              <Btn color="success" className="w-100">
                                CTA
                              </Btn>
                            </Link>
                            <Link
                              to={`/blogs/edit/${item.id}`}
                              className="w-100"
                            >
                              <Btn
                                color="success"
                                className="w-100 d-flex justify-content-center gap-2 align-items-center"
                              >
                                <svg
                                  id="Layer_1"
                                  enable-background="new 0 0 512 512"
                                  viewBox="0 0 512 512"
                                  style={{ width: "1rem", height: "1rem" }}
                                  fill="#fff"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g id="Layer_2_00000133488136334355325770000017040564409625911724_">
                                    <g id="pen_line">
                                      <path d="m419 222.2-.3-.3-129-129.1s-157.2 157.2-233 234.6c-9.4 9.6-16.6 23-20.8 36-12.4 38-22.7 76.8-34.2 115.1-3.1 10.3-2.5 19.4 5.6 27 7.6 7.2 16.2 7.6 26 4.6 36.6-11 73.4-21.4 110.1-31.9 19.3-5.5 35.5-15.7 49.7-30 72.2-72.5 225.9-226 225.9-226z" />
                                      <path d="m494.3 61.8-44.1-44.1c-23.6-23.6-61.7-23.6-85.3 0l-50 50 129.4 129.4 50-50c23.6-23.5 23.6-61.7 0-85.3z" />
                                      <path d="m230.6 457.8h254.3c15 0 27.1 12.1 27.1 27.1s-12.1 27.1-27.1 27.1h-254.3c-15 0-27.1-12.1-27.1-27.1.1-15 12.2-27.1 27.1-27.1z" />
                                    </g>
                                  </g>
                                </svg>
                                Edit
                              </Btn>
                            </Link>
                            {/* Only show Publish/Unpublish if scheduledDate <= today */}
                            {canPublish(item.scheduledDate) && (
                              <Btn
                                key={`publish-btn-${item.id}-${item.isPublished}`} // 👈 forces re-render
                                color={item.isPublished ? "warning" : "success"}
                                className="w-100 d-flex justify-content-center gap-2 align-items-center"
                                onClick={() =>
                                  togglePublish(item.id, item.isPublished)
                                }
                              >
                                <EyeIcon
                                  key={`eye-icon-${item.id}-${item.isPublished}`} // 👈 forces icon refresh
                                  published={item.isPublished}
                                />
                                <span>
                                  {item.isPublished ? "UnPublish" : "Publish"}
                                </span>
                              </Btn>
                            )}
                            <Btn
                              color="danger"
                              onClick={() => {
                                setSelectedBlogId(item.id);
                                setModalOpen(true);
                              }}
                              className="w-100 d-flex justify-content-center gap-2 align-items-center"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 512 512"
                                width={512}
                                className="flex-shrink-0"
                                style={{ width: "1rem", height: "1rem" }}
                                height={512}
                              >
                                <g id="Remove">
                                  <line
                                    x1="56"
                                    y1="100"
                                    x2="456"
                                    y2="100"
                                    stroke="#fff"
                                    strokeWidth="40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    fill="none"
                                  />
                                  <path
                                    d="M176,100V60c0-22.091,17.909-40,40-40h80c22.091,0,40,17.909,40,40v40"
                                    stroke="#fff"
                                    strokeWidth="40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    fill="none"
                                  />
                                  <path
                                    d="M96,100v312c0,44.183,35.817,80,80,80h160c44.183,0,80-35.817,80-80V180"
                                    stroke="#fff"
                                    strokeWidth="40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    fill="none"
                                  />
                                  <line
                                    x1="176"
                                    y1="220"
                                    x2="176"
                                    y2="412"
                                    stroke="#fff"
                                    strokeWidth="40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    fill="none"
                                  />
                                  <line
                                    x1="256"
                                    y1="220"
                                    x2="256"
                                    y2="412"
                                    stroke="#fff"
                                    strokeWidth="40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    fill="none"
                                  />
                                  <line
                                    x1="336"
                                    y1="220"
                                    x2="336"
                                    y2="412"
                                    stroke="#fff"
                                    strokeWidth="40"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeMiterlimit="10"
                                    fill="none"
                                  />
                                </g>
                              </svg>
                              Delete
                            </Btn>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    {/* <UserCardsFooter item={item} /> */}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
      {selectedBlogId !== null && (
        <CenteredModal
          isOpen={modalOpen}
          toggle={() => setModalOpen(false)}
          blogId={selectedBlogId}
          url={"/blogs"}
          onDeleteSuccess={handleDeleteSuccess}
        />
      )}
    </>
  );
};

export default BlogCardsContainer;
